import Vue from 'vue'
import VueRouter from 'vue-router'

import Icon from "../views/biz/tool/icon";

import FndUserQuery from "../views/fnd/user/FndUserQuery";
import FndUserDetail from "../views/fnd/user/FndUserDetail";
import FndRoleQuery from "../views/fnd/role/FndRoleQuery";
import FndRoleDetail from "../views/fnd/role/FndRoleDetail";
import FndMenuQuery from "../views/fnd/menu/FndMenuQuery";
import FndMenuDetail from "../views/fnd/menu/FndMenuDetail";
import FndPermissionQuery from "../views/fnd/permission/FndPermissionQuery";
import FndPermissionDetail from "../views/fnd/permission/FndPermissionDetail";
import FndRestQuery from "../views/fnd/rest/FndRestQuery";
import FndRestDetail from "../views/fnd/rest/FndRestDetail";
import SealDetail from "../views/biz/seal/SealDetail";
import SealQuery from "../views/biz/seal/SealQuery";
import TemplateQuery from "../views/biz/template/TemplateQuery";
import TemplateDetail from "../views/biz/template/TemplateDetail";
import DocQuery from "../views/biz/doc/DocQuery";
import DocEditor from "../views/biz/doc/DocEditor";
import TypeEngine from "../views/biz/doc/TypeEngine";
import TodoQuery from "../views/biz/bpm/TodoQuery";
import DocEditPreview from "../views/biz/doc/DocEditPreview";
import TemplateEngine from "../views/biz/template/TemplateEngine";
import path from './menu'

import ContainerDetail from "../views/biz/doc/ContainerDetail";
import ContainerQuery from "../views/biz/doc/ContainerQuery";
import RecordQuery from "../views/biz/doc/RecordQuery";
import ItemQuery from "../views/biz/doc/ItemQuery";
import MixCodeQuery from "../views/biz/doc/MixCodeQuery";
import BoxQuery from "@/views/biz/box/BoxQuery";
import BoxDetail from "@/views/biz/box/BoxDetail";
import RegularCodeQuery from "@/views/biz/box/RegularCodeQuery";


const routes = [
    {path: '/', name: "home", component: ContainerQuery},
    {path: '/tool/icon', name: "icon", component: Icon},
    {path: '/user', name: "user", component: FndUserQuery},
    {path: '/user/detail', name: "userDetail", component: FndUserDetail},
    {path: '/role', name: "role", component: FndRoleQuery},
    {path: '/role/detail', name: "roleDetail", component: FndRoleDetail},
    {path: '/menu', name: "menu", component: FndMenuQuery},
    {path: '/menu/detail', name: "menuDetail", component: FndMenuDetail},
    {path: '/permission', name: "permission", component: FndPermissionQuery},
    {path: '/permission/detail', name: "permissionDetail", component: FndPermissionDetail},
    {path: '/rest', name: "rest", component: FndRestQuery},
    {path: '/rest/detail', name: "restDetail", component: FndRestDetail},
    {path: '/seal', name: "seal", component: SealQuery},
    {path: '/seal/detail', name: "sealDetail", component: SealDetail},
    {path: '/template', name: "template", component: TemplateQuery},
    {path: '/template/detail', name: "templateDetail", component: TemplateDetail},
    {path: '/template/engine', name: "templateEngine", component: TemplateEngine},
    {path: '/doc', name: "doc", component: DocQuery},
    {path: '/engine', name: "engine", component: TypeEngine},
    {path: '/doc/detail', name: "docDetail", component: ContainerDetail,meta: {keepAlive: false}},
    {path: '/doc/editor', name: "docEditor", component: DocEditor},
    {path: '/doc/preview', name: "preview", component: DocEditPreview},
    {path: '/todo', name: "todo", component: TodoQuery},
    {path: '/container/query', name: "containerQuery", component: ContainerQuery,meta: {keepAlive: true}},
    {path: '/record/query', name: "recordQuery", component: RecordQuery,meta: {keepAlive: true}},
    {path: '/item/query', name: "itemQuery", component: ItemQuery},
    {path: '/regular/query', name: "regularQuery", component: RegularCodeQuery},
    {path: '/mixcode/query', name: "mixcodeQuery", component: MixCodeQuery},
    {path: '/box/query', name: "boxQuery", component: BoxQuery,meta: {keepAlive: true}},
    {path: '/box/detail', name: "boxDetail", component: BoxDetail,meta: {keepAlive: false}},
]

Vue.use(VueRouter)

const router = new VueRouter({
    mode: "hash",
    linkActiveClass: "active",
    routes: routes
})

router.beforeEach((to, from, next) => {
    //控制首页和app内部页面
    let m = to.path.match(/\/project\/([^\\/]+)\//);
    if (m) {
        let projectId = m[1];
        localStorage.setItem("httpHeader", JSON.stringify({
            projectId: projectId
        }));
        localStorage.setItem("globalRouteParams", JSON.stringify({
            projectId: projectId
        }));
    }

    //控制未登录路由到首页
    // if (to.path == '/' || to.path == '' || to.path == '/#/') {
    //     if (window.appConfig.container && window.appConfig.container == 'app') {
    //         window.location.href = '/';
    //     } else {
    //         next();
    //     }
    //     return;
    // } else if (window.appConfig.container && window.appConfig.container == 'home') {
    //     location.reload();
    //     return;
    // }
    // let token = localStorage.getItem('token');
    // if (!token) {
    //     window.location.href = '/';
    //     return;
    // }

    next();
})

router.apmRoute = (to, query, params, source) => {
    let routerInfo = router.routerInfo(to);
    if (routerInfo) {
        if (source) {
            routerInfo.source = source;
        }
        query = Object.assign(routerInfo.query || {}, query || {});
        routerInfo.query = query;
    }
    params = Object.assign(params || {}, JSON.parse(localStorage.getItem("globalRouteParams") || "{}"));
    router.push({name: routerInfo.router.name, query: query, params: params});
}

router.goBack = () => {
    router.go(-1);
    window.theApp.$emit("ROUTER_GOBACK");
}

/**
 * 获取路由信息
 * path先根据name进行查找，如果没找到再按照path进行查找
 */
router.routerInfo = (to) => {
    let index = to.indexOf('?');
    let result = {};
    if (index != -1) {
        let query = {};
        //解析参数
        let uri = to.slice(index + 1, to.length);
        to = to.slice(0, index);
        uri.split('&').forEach(item => {
            let items = item.split('=');
            if (items.length > 1) {
                query[items[0]] = items[1];
            }
        })
        result.query = query;
    }
    let routerItem = routes.filter(item => item.name == to).pop();
    if (!routerItem) {
        routerItem = routes.filter(item => item.path == to).pop();
    }
    if (!routerItem) {
        return;
    }
    result.router = routerItem;
    let meta = path.filter(item => item.path && (item.path == routerItem.path || "/" + item.path == routerItem.path)).pop();

    //先从根结点获取，如果找不到再从chidren节点获取
    if (!meta || meta.length == 0) {
        path.filter(item => item.children).forEach(item => {
            item.children.forEach(row => {
                if (row.path == routerItem.path || "/" + row.path == routerItem.path) {
                    meta = row;
                }
            })
        })
    }

    //路由信息不在菜单里
    if (!meta) {
        meta = {
            name: routerItem.title
        }
    }
    result.meta = meta;
    return result;
}

export default router;
